import React, { useEffect, useRef } from 'react';
import './Banner.css';

function Banner({ hideContent = false }) {
  const bannerRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (bannerRef.current) {
        const scrollY = window.scrollY;
        const speed = 0.35;
        bannerRef.current.style.transform = `translateY(${scrollY * speed}px)`;
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section className="banner">
      <div className="banner__image-wrapper">
        <img
          ref={bannerRef}
          src="/unimar-boats-collection.webp"
          alt="Aerial view of boats gathered on turquoise water"
          className="banner__image"
        />
      </div>

      {/* Dark gradient overlay for text readability */}
      <div className="banner__overlay" />

      {/* Content */}
      {!hideContent && (
        <div className="banner__content">
          <p className="banner__tagline">Crafted for the Open Water</p>
          <h1 className="banner__title">
            Build Your <br className="banner__br-desktop" />
            Dream Boat
          </h1>
          <p className="banner__subtitle">
            Configure every detail — from hull to horizon.
          </p>
          <a href="/configurator" className="banner__cta">
            Start Configuring
            <svg
              className="banner__cta-arrow"
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
            >
              <path
                d="M4 9H14M14 9L10 5M14 9L10 13"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </a>
        </div>
      )}

      {/* Scroll indicator */}
      <div className="banner__scroll-indicator">
        <div className="banner__scroll-line" />
      </div>
    </section>
  );
}

export default Banner;
